import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            // name: 'home',
            component: resolve => require(['@/components/Home.vue'], resolve),
            meta: {
                title: "和云网科"
            }
        }, {
            path: '/home',
            name: 'home',
            component: resolve => require(['@/components/Home.vue'], resolve),
            meta: {
                title: "和云网科-首页"
            }
        }, {
            path: '/informationService',
            name: 'informationService',
            component: resolve => require(['@/components/InformationService.vue'], resolve),
            meta: {
                title: "和云网科-信息查询"
            }
        }, {
            path: '/drugDetails/:drugId',
            name: 'drugDetails',
            component: resolve => require(['@/common/drugDetails.vue'], resolve),
            meta: {
                title: "和云网科-药品信息"
            }
        }, {
            path: '/infoListView',
            name: 'infoListView',
            component: resolve => require(['@/components/InfoListView.vue'], resolve),
            meta: {
                title: "和云网科-信息发布"
            }
        }, {
            path: '/infoDetailsView/:id',
            name: 'infoDetailsView',
            component: resolve => require(['@/components/InfoDetailsView.vue'], resolve),
            meta: {
                title: "和云网科-信息发布详情"
            }
        }, {
            path: '/healthKnowledge',
            name: 'healthKnowledge',
            component: resolve => require(['@/components/HealthKnowledge.vue'], resolve),
            meta: {
                title: "和云网科-健康常识"
            }
        }, {
            path: '/aboutUs',
            name: 'aboutUs',
            component: resolve => require(['@/components/AboutUs.vue'], resolve),
            meta: {
                title: "和云网科-关于我们"
            }
        }, {
            path: '/supervise',
            name: 'supervise',
            component: resolve => require(['@/components/supervise/supervise.vue'], resolve),
            meta: {
                title: "和云网科-管理页"
            },
            children: [
                {
                    path: '/aboutus',
                    name: 'aboutus',
                    component: resolve => require(['@/components/AboutUs.vue'], resolve),
                    meta: {
                        title: "和云网科-关于我们"
                    }
                }
            ]
        }
    ]
})
